/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
//
//
//
//
//
//
//
//
export default {
  name: 'FormMobile',
  props: {
    model: Object,
    rules: Object,
    autocomplete: {
      validator: function validator(value) {
        return ['on', 'off'].includes(value);
      },
      default: 'off'
    }
  },
  data: function data() {
    return {};
  },
  computed: {
    fields: function fields() {
      return Array.from(this.$slots.default).filter(function (v) {
        return v.tag && v.data && v.data.attrs && v.data.attrs.prop;
      });
    }
  },
  methods: {
    validate: function validate(callback) {
      var _this = this;

      return new Promise(function (resolve) {
        var valid = true;

        var isEmpty = function isEmpty(e) {
          return Boolean(e === '' || e === undefined || e === null);
        };

        for (var index = 0; index < _this.fields.length; index++) {
          var field = _this.fields[index];
          var key = field.data.attrs.prop;
          var tmp = _this.rules[key];

          if (Array.isArray(tmp)) {
            // 只控制是否填写
            tmp = tmp.find(function (v) {
              return v.required;
            });
          }

          if (tmp && tmp.required) {
            valid = !isEmpty(_this.model[key]);
          }

          if (valid === false) {
            resolve(valid);

            if (typeof callback === 'function') {
              callback(valid);
            }

            break;
          }
        }

        resolve(valid);
      });
    }
  }
};